/*LIBRARY*/
import { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

/*COMPONENT*/
import Modal from "../../Components/common_modal/Modal";
import SpinnerSimpleBlue from "../../Components/common_spinner/SpinnerSimpleBlue";
import FLOAT_MENU from "../../Components/common_trivial/FLOAT_MENU";

import Yes from "../../Assets/svg/tick-circle.svg";

/*REDUX*/
import { openModal } from "../../App/actions/authActions";
import {
  addGroup,
  getGroups,
  deleteGroup,
  editGroup,
  searchUser,
} from "../../App/actions/groupActions";
import { getUserPaymentList } from "../../App/actions/paymentActions";
import { delete_collaborator } from "../../App/actions/license_actions";
import { set_value_user } from "../../App/actions/authActions";
import {
  block_license_with_handler,
  is_pass_license_sharing,
} from "../../App/actions/filter_license";
import { post_activities } from "../../App/actions/activities";

/*PICTURE*/
import ICON_PLUS from "../../Assets/jsx/ICON_PLUS";
import menu_icon from "../../Assets/svg/menu_icon.svg";
import icon_group from "../../Assets/svg/icon_group.svg";

/*FUNCTION*/
import isEmpty from "../../App/validation/is-empty";
import formatDate from "../../App/validation/format-date";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const GROUP_MENU = ({
  auth,
  license_reducer,
  getGroups,
  getUserPaymentList,
  block_license_with_handler,
  is_pass_license_sharing,
  deleteGroup,
  addGroup,
  editGroup,
  delete_collaborator,
  post_activities,
}) => {
  const { groups, user, loading, loadingDetail } = auth;
  const {
    license_basic,
    license_sharing,
    license_user_status,
    license_group_status,
  } = license_reducer;

  const [modal_add_group, set_modal_add_group] = useState(false);
  const [modal_delete, set_modal_delete] = useState(false);
  const [modal_edit, set_modal_edit] = useState(false);
  const [name, set_name] = useState("");
  const [group_state, set_group_state] = useState(null); // Will hold selected group object
  const [modal_menu, set_modal_menu] = useState(false); // controls FLOAT_MENU visibility
  const [anchor, set_anchor] = useState(null); // anchor element for FLOAT_MENU positioning
  // const [status_user, set_status_user] = useState(""); // user status relative to selected group
  const [modal_filter, set_modal_filter] = useState(false);
  const [roles] = useState(["creator", "admin", "viewer", "contributor"]);
  const [selectedRoles, set_selectedRoles] = useState([
    "creator",
    "admin",
    "viewer",
    "contributor",
  ]);
  const [group_types] = useState(["internal", "external"]);
  const [selected_group_types, set_selected_group_types] = useState([
    "internal",
    "external",
  ]);
  const [modal_roles_rules, set_modal_roles_rules] = useState(false);
  const [is_external, set_is_external] = useState(false);
  const [contentDelete, set_contentDelete] = useState(null);

  const timer = useRef(null);

  useEffect(() => {
    getUserPaymentList();
    getGroups();
  }, [getUserPaymentList, getGroups]);

  useEffect(() => {
    set_modal_add_group(false);
    set_modal_edit(false);
  }, [groups]);

  const toggle_edit = (group) => {
    if (is_pass_license_sharing()) {
      if (group) {
        set_group_state(group);
        set_name(group.name);
        set_is_external(group.is_external);
      }
      set_modal_edit(!modal_edit);
      set_modal_menu(false);
      set_anchor(null);
    } else {
      block_license_with_handler();
      set_modal_edit(false);
      set_modal_menu(false);
      set_anchor(null);
    }
  };

  const onDeleteClick = () => {
    const content = {
      group_id: group_state._id,
    };
    deleteGroup(content);
    set_modal_delete(false);
    set_group_state(null);
  };

  const toggle_delete = (type, group) => {
    const language = localStorage?.language || "ina";
    const { collaborators } = auth;

    if (type === "group") {
      if (group) {
        set_group_state(group);
      }
      set_modal_delete(!modal_delete);
      set_modal_menu(false);
      set_anchor(null);
      set_contentDelete(
        <div className="box-body" style={{ textAlign: "center" }}>
          <p>{dict["Are you sure to delete this group?"][language]}</p>
          <br />
          <h2>{group.name}</h2>
          <br />
          <button
            className="button_very_small background_red"
            data-mapid="clickDeleteModal"
            onClick={onDeleteClick}
          >
            {dict["Delete"][language]}
          </button>
        </div>,
      );
    } else if (type === "collaborator") {
      set_contentDelete(
        <div className="box-body" style={{ textAlign: "center" }}>
          <p>{"Are you sure to delete this collaborator?"}</p>
          <br />
          <h2>{group.full_name}</h2>
          <br />
          <button
            className="button_very_small background_red"
            data-mapid="clickDeleteModal"
            onClick={() => {}}
          >
            {dict["Delete"][language]}
          </button>
        </div>,
      );
      const p_id = license_basic?._id || license_user_status?._id;

      delete_collaborator(group, collaborators, p_id);
    }
  };

  const handleChange = (e) => {
    const { name: targetName, value } = e.target;
    if (targetName === "name") {
      set_name(value);
    }
    if (targetName === "search_user") {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        searchUser(value);
      }, 2000);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const collaborator_id =
      license_sharing?.collaborator_id ||
      license_group_status?.collaborator_id ||
      license_basic?.collaborator_id ||
      license_user_status?.collaborator_id;

    const content = {
      name,
      collaborator_id,
      is_external: is_external,
    };

    addGroup(content);

    post_activities({
      action: "create_group",
    });
  };

  const handleSubmitEdit = (e) => {
    e.preventDefault();
    const content = {
      group_name: name,
      group_id: group_state._id,
      is_external: is_external,
    };
    editGroup(content);
    set_modal_edit(false);
    set_group_state(null);
  };

  const toggle_add_group = () => {
    if (is_pass_license_sharing()) {
      set_modal_add_group(!modal_add_group);
    } else {
      block_license_with_handler();
    }
  };

  const toggle_menu = (event) => {
    if (event) {
      event.preventDefault();
      const group_id = event.currentTarget?.dataset?.groupId;
      const group = groups.find((g) => g._id === group_id);

      if (!group) return;

      // const member = group.members.find(
      //   (m) => (m?.user?._id ? m.user._id : m?.user) === user._id,
      // );
      // const calculated_status_user =
      //   member && member.status && member.status !== "accepted"
      //     ? member.status
      //     : "viewer";

      set_modal_menu(!modal_menu);
      set_anchor(event.currentTarget);
      set_group_state(group);
      // set_status_user(calculated_status_user);
    } else {
      set_modal_menu(false);
      set_anchor(null);
      set_group_state(null);
      // set_status_user("");
    }
  };

  const toggle_filter = (event) => {
    if (event) {
      set_modal_filter(!modal_filter);
      set_anchor(event.currentTarget);
    } else {
      set_modal_filter(false);
      set_anchor(null);
    }
  };

  const setFilter = (dt) => {
    let updatedRoles = [...selectedRoles];
    let updatedTypes = [...selected_group_types];

    if (dt.role && dt.role !== "All") {
      if (updatedRoles.includes(dt.role)) {
        updatedRoles = updatedRoles.filter((item) => item !== dt.role);
      } else {
        updatedRoles.push(dt.role);
      }
      set_selectedRoles(updatedRoles);
    } else if (dt.type) {
      if (updatedTypes.includes(dt.type)) {
        updatedTypes = updatedTypes.filter((item) => item !== dt.type);
      } else {
        updatedTypes.push(dt.type);
      }
      set_selected_group_types(updatedTypes);
    } else if (dt.role === "All") {
      if (updatedRoles.length > 0) {
        set_selectedRoles([]);
        set_selected_group_types([]);
      } else {
        set_selectedRoles(["creator", "admin", "viewer", "contributor"]);
        set_selected_group_types(["internal", "external"]);
      }
    }
  };

  const rolesRule = () => {
    set_modal_roles_rules(!modal_roles_rules);
  };

  const language = localStorage?.language || "ina";

  let group_list_content;
  let icon_edit_content;
  let loading_content;

  let icon_content = (
    <button
      className="button background_black"
      onClick={handleSubmit}
      type="submit"
      data-mapid="clickSave"
    >
      {dict["Save"][language]}
    </button>
  );

  if (loadingDetail && isEmpty(groups)) {
    loading_content = (
      <SpinnerSimpleBlue
        width={200}
        unik="loading_item_list"
        marginTop="0px"
        center={true}
        border={0.1}
      />
    );
  } else if (!isEmpty(groups)) {
    if (loading) {
      icon_content = (
        <SpinnerSimpleBlue
          width={48}
          unik="loading_item_list"
          marginTop="0px"
          center={true}
          border={0.1}
        />
      );
      icon_edit_content = (
        <SpinnerSimpleBlue
          width={48}
          unik="loading_item_list"
          marginTop="0px"
          center={true}
          border={0.1}
        />
      );
    } else {
      icon_edit_content = (
        <button
          className="button background_black margin_top"
          type="submit"
          onClick={handleSubmitEdit}
          data-mapid="clickSaveEdit"
        >
          {dict["Save"][language]}
        </button>
      );
    }

    let selectedGroup = groups.filter((group) => {
      const { members = [], is_external: group_is_external } = group;

      const member = members.find(
        (m) => (m?.user?._id ? m?.user?._id : m?.user) === user._id,
      );

      if (!member) return false;

      const calculated_status_user =
        member?.status && member.status !== "accepted"
          ? member.status
          : "viewer";

      const group_type = group_is_external ? "external" : "internal";
      const matchRole = selectedRoles.includes(calculated_status_user);
      const matchType = selected_group_types.includes(group_type);

      return matchRole && matchType;
    });

    group_list_content = (
      <main
        style={{
          display: "inline-block",
          verticalAlign: "top",
        }}
      >
        {selectedGroup.map((group, idx) => {
          const {
            name: group_name,
            members,
            _id,
            date,
            is_external: group_is_external,
          } = group;

          const member = members.find(
            (m) => (m?.user?._id ? m?.user?._id : m?.user) === user._id,
          );
          const calculated_status_user =
            member && member?.status && member?.status !== "accepted"
              ? member.status
              : "viewer";

          return (
            <main
              className="container_project background_white outline_grey"
              key={idx}
              style={{ verticalAlign: "top", position: "relative" }}
            >
              <section
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  width: "100%",
                  boxSizing: "border-box",
                }}
              >
                <div id="part_1" style={{ flex: 1, overflow: "hidden" }}>
                  <p
                    className={`badge margin_right margin_bottom green_container`}
                  >
                    {members.length} {members.length > 1 ? "members" : "member"}
                  </p>
                </div>
                <div id="part_2" style={{ width: "50px", textAlign: "right" }}>
                  {calculated_status_user === "creator" && (
                    <button
                      onClick={toggle_menu}
                      data-group-id={_id}
                      className="button button_white"
                      style={{ width: "30px" }}
                      data-mapid={`group_${idx}_toggle`}
                    >
                      <img alt="menu" src={menu_icon} height={15} />
                    </button>
                  )}
                </div>
              </section>

              <section>
                <p
                  className="text_bold"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={group_name}
                >
                  {group_name}
                </p>
              </section>

              <section
                style={{
                  position: "absolute",
                  bottom: 5,
                  boxSizing: "border-box",
                  width: "calc( 100% - 30px )",
                  padding: 0,
                }}
              >
                <div
                  style={{
                    backgroundColor: "transparent",
                    borderTop: "2px solid #e6e6e6",
                    marginBottom: 5,
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    alignItems: "flex-start",
                  }}
                >
                  <section
                    id="part_1"
                    style={{ flex: 1, paddingRight: "10px" }}
                  >
                    <p className="text_small margin_bottom">
                      {date && (
                        <>
                          {dict["Created at"][language]}: {formatDate(date)}
                        </>
                      )}
                    </p>
                    <br />
                    <button
                      onClick={rolesRule}
                      className={`badge_small margin_bottom margin_right ${
                        ["owner"].includes(calculated_status_user)
                          ? "dark_blue_container"
                          : ["admin"].includes(calculated_status_user)
                            ? "green_container"
                            : ["creator"].includes(calculated_status_user)
                              ? "orange_container"
                              : ["contributor"].includes(calculated_status_user)
                                ? "blue_container"
                                : "grey_container"
                      }`}
                    >
                      {calculated_status_user.charAt(0).toUpperCase() +
                        calculated_status_user.slice(1)}
                    </button>
                    <p
                      className={`badge_small margin_bottom ${
                        group_is_external
                          ? "dark_blue_container"
                          : "grey_container"
                      }`}
                    >
                      {`${group_is_external ? "External Group" : "Internal Group"}`}
                    </p>
                  </section>

                  <section id="part_2" style={{ width: "50px" }}>
                    <Link to={`/group/${_id}`}>
                      <div
                        className="text_below_icon"
                        style={{
                          marginRight: "15px",
                          textAlign: "center",
                          width: "100%",
                        }}
                      >
                        <img
                          src={icon_group}
                          height="30px"
                          alt="Group"
                          data-mapid={`clickGroupDetail-${idx}`}
                        />
                        <p style={{ margin: 0 }}>Detail</p>
                      </div>
                    </Link>
                  </section>
                </div>
              </section>
            </main>
          );
        })}
      </main>
    );
  }

  const modalDelete = modal_delete && (
    <Modal
      modalSize="small"
      isOpen={modal_delete}
      onClose={() => set_modal_delete(false)}
    >
      {contentDelete}
    </Modal>
  );

  const modalEdit = modal_edit && (
    <Modal
      modalSize="small"
      isOpen={modal_edit}
      onClose={() => set_modal_edit(false)}
    >
      <div>
        <button
          className={`${
            is_external ? "checklist_active" : "checklist_not"
          }  margin_bottom margin_right`}
          onClick={() => {
            set_is_external(!is_external);
          }}
        />
        external group
      </div>
      <div className="box-body" style={{ textAlign: "center" }}>
        <form onSubmit={handleSubmitEdit}>
          <input
            className="input_square"
            type="text"
            name="name"
            id="name"
            value={name}
            onChange={handleChange}
            data-mapid="editInputGroup"
            autoFocus
          />
          <div style={{ marginTop: 15 }}>{icon_edit_content}</div>
        </form>
      </div>
    </Modal>
  );

  let create_group_content = <p>Pending</p>;

  if (
    license_basic?.is_has_license ||
    license_sharing?.is_has_license ||
    license_user_status?.is_has_license ||
    license_group_status?.is_has_license
  ) {
    create_group_content = (
      <main>
        <div>
          <button
            className={`${
              is_external ? "checklist_active" : "checklist_not"
            }  margin_bottom margin_right`}
            onClick={() => {
              set_is_external(!is_external);
            }}
          />
          external group
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              className="input_square"
              type="text"
              name="name"
              id="name"
              value={name}
              onChange={handleChange}
              data-mapid="inputNamaGroup"
              autoFocus
            />
            <div className="text-center" style={{ marginTop: 15 }}>
              {icon_content}
            </div>
          </div>
        </form>
      </main>
    );
  }

  const modal_add_group_content = modal_add_group && (
    <Modal
      modalSize="small"
      isOpen={modal_add_group}
      onClose={() => set_modal_add_group(false)}
      title={dict["Create a new group"][language]}
    >
      <div className="box-body">{create_group_content}</div>
    </Modal>
  );

  const floatMenuContent = (
    <FLOAT_MENU
      id="group-list-float-menu"
      anchorEl={anchor}
      open={modal_menu}
      onClose={() => toggle_menu()}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
      style={{ borderRadius: "15px" }}
    >
      <div>
        <button
          className="button_big margin_bottom button_white"
          onClick={() => toggle_edit(group_state)}
          data-mapid="clickEditGroup"
          style={{ width: "100%", textAlign: "left" }}
        >
          {dict["Edit"][language]}
        </button>

        <button
          className="button_big button_white"
          onClick={() => toggle_delete("group", group_state)}
          data-mapid="clickDeleteGroup"
          style={{ width: "100%", textAlign: "left" }}
        >
          {dict["Delete"][language]}
        </button>
      </div>
    </FLOAT_MENU>
  );

  const filterContent = (
    <FLOAT_MENU
      id="filter-float-menu"
      anchorEl={anchor}
      open={modal_filter}
      onClose={() => toggle_filter()}
    >
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td>
              <button
                className={
                  selectedRoles.length === roles.length
                    ? "checklist_active"
                    : "checklist_not"
                }
                onClick={() => setFilter({ role: "All" })}
              />
            </td>
            <td className="side">{dict?.["All"]?.[language] || "All"}</td>
          </tr>
          {roles.map((dt, index) => {
            return (
              <tr key={index}>
                <td>
                  <button
                    className={
                      selectedRoles.includes(dt)
                        ? "checklist_active"
                        : "checklist_not"
                    }
                    onClick={() => setFilter({ role: dt })}
                  />
                </td>
                <td className="side">{dt}</td>
              </tr>
            );
          })}
          {group_types.map((dt, index) => {
            return (
              <tr key={index}>
                <td>
                  <button
                    className={
                      selected_group_types.includes(dt)
                        ? "checklist_active"
                        : "checklist_not"
                    }
                    onClick={() => setFilter({ type: dt })}
                  />
                </td>
                <td className="side">{dt}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </FLOAT_MENU>
  );

  const modal_roles_rules_content = modal_roles_rules && (
    <Modal
      modalSize="medium"
      isOpen={modal_roles_rules}
      onClose={() => set_modal_roles_rules(false)}
    >
      <div style={{ overflowX: "auto" }}>
        <h2 style={{ marginBottom: "20px", fontFamily: "sans-serif" }}>
          Aturan Role Grup
        </h2>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontFamily: "sans-serif",
            fontSize: "14px",
          }}
        >
          <thead>
            <tr style={{ background: "#f5f5f5", textAlign: "left" }}>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}></th>
              {roles.map((dt, idx) => {
                return (
                  <th
                    key={idx}
                    style={{ padding: "10px", border: "1px solid #ddd" }}
                  >
                    <p
                      className={`badge margin_bottom ${
                        ["owner"].includes(dt)
                          ? "dark_blue_container"
                          : ["admin"].includes(dt)
                            ? "green_container"
                            : ["creator"].includes(dt)
                              ? "orange_container"
                              : ["contributor"].includes(dt)
                                ? "blue_container"
                                : "grey_container"
                      }`}
                    >
                      {dt}
                    </p>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {[
              [
                dict?.["Deleting a group"]?.[language],
                "ya",
                "tidak",
                "tidak",
                "tidak",
              ],
              [
                dict?.["Rename a group"]?.[language],
                "ya",
                "tidak",
                "tidak",
                "tidak",
              ],
              [
                dict?.["Adding members to a group"]?.[language],
                "ya",
                "ya",
                "tidak",
                "tidak",
              ],
              [
                dict?.["Changing member roles in a group"]?.[language],
                "ya",
                "tidak",
                "tidak",
                "tidak",
              ],
              [
                dict?.["Delete member"]?.[language],
                "ya",
                "ya",
                "tidak",
                "tidak",
              ],
              [""], // pemisah
              [
                dict?.["Adding a group to a project"]?.[language],
                "ya",
                "ya",
                "tidak",
                "tidak",
              ],
              [
                dict?.["View the collaborative project editor map"]?.[language],
                "ya",
                "ya",
                "ya",
                "tidak",
              ],
              [
                dict?.["View the collaborative project map viewer"]?.[language],
                "ya",
                "ya",
                "ya",
                "ya",
              ],
              [
                dict?.["Submit the form in the collaboration project"]?.[
                  language
                ],
                "ya",
                "ya",
                "ya",
                "ya",
              ],
            ].map((row, idx) =>
              row.length === 1 && row[0] === "" ? (
                <tr key={idx}>
                  <td
                    colSpan={5}
                    style={{ background: "#eee", height: "10px", padding: 0 }}
                  />
                </tr>
              ) : (
                <tr
                  key={idx}
                  style={{
                    background: idx % 2 === 0 ? "#fff" : "#fafafa",
                  }}
                >
                  {row.map((col, cIdx) => (
                    <td
                      key={cIdx}
                      style={{
                        padding: "10px",
                        border: "1px solid #ddd",
                        textAlign: "center",
                      }}
                    >
                      {col === "ya" ? (
                        <img src={Yes} alt="yes" width={20} />
                      ) : col === "tidak" ? (
                        "-"
                      ) : (
                        col
                      )}
                    </td>
                  ))}
                </tr>
              ),
            )}
          </tbody>
        </table>
      </div>
    </Modal>
  );

  return (
    <main className="footer_margin">
      <div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <button
            onClick={toggle_add_group}
            className="button_pill background_white margin_bottom margin_right"
            data-mapid="clickNewGroup"
          >
            <span className="badge_circle background_green margin_right">
              <ICON_PLUS />
            </span>
            {dict["New Group"][language]}
          </button>
          <div>
            <button
              className="button_big background_white rounded"
              onClick={toggle_filter}
            >
              Filter
            </button>
            {filterContent}
          </div>
        </div>
        <br />
        {loading_content}
        {group_list_content}
        {modal_add_group_content}
        {modalDelete}
        {modalEdit}
        {floatMenuContent}
        {modal_roles_rules_content}
        <Helmet>
          <title>{dict["Group"][language]}</title>
          <meta name="description" content={dict["Group"][language]} />
        </Helmet>
      </div>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  payment: state.payment,
  license_reducer: state.license_reducer,
});

export default connect(mapStateToProps, {
  addGroup,
  getGroups,
  deleteGroup,
  editGroup,
  searchUser,
  getUserPaymentList,
  openModal,
  set_value_user,
  delete_collaborator,
  is_pass_license_sharing,
  block_license_with_handler,
  post_activities,
})(GROUP_MENU);
